export function DashboardFilledSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/dashboard-filled.svg'"></ng-include>`
    }
}